import * as React from "react";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import UserSearchFilterEdit from "search-filter/components/filter-management-pages/UserSearchFilterEdit";
import SearchFilterPageSubactions from "search-filter/components/filter-management-pages/SearchFilterPageSubactions";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersEditPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: 'Edit Filter From "My Filters" Collection' }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: 'Edit Filter From "My Filters" Collection',
      actions: /* @__PURE__ */ React.createElement(SearchFilterPageSubactions, null),
      documentationLink: {
        title: "Search filter documentation",
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, 'Edit a filter from your "My Filters" collection. Please note, changing a filter will affect all saved searches and dashboard widgets which include this filter.')
  ), isValidLicense ? /* @__PURE__ */ React.createElement(UserSearchFilterEdit, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: "search filter",
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersEditPage;
